import React from 'react';

export default function ConfrimationPage() {
  return (
    <div>
      <h3 style={{ margin: '1em' }}>Your application has been submitted!</h3>
      <p style={{ margin: '2em' }}>
        To activate your membership, verify your email address by clicking the
        link in the email we sent, and proceed to SCE (Engr 294) to complete
        registration and memberhip payment. You may now return to the homepage!
      </p>
    </div>
  );
}
